/**
 * Vendor-aware support contact for anyone stuck on email verification, shared
 * by the sign-up gate screens and the per-action verify prompt.
 */

import { getVendorContent } from '@studio/design-system/themes/vendor.js';
import { ElectronAPI } from '#~/electron/index.js';

/** Support inbox for the running whitelabel. */
export const supportEmail = (): string =>
  getVendorContent({ iris: 'irissupport@audinate.com', ptzoptics: 'hive-support@tryiris.ai' });

/** Open the support mailto in a context-correct way (Electron IPC vs browser). */
export const openSupport = (): void => {
  // ElectronAPI.openUrl handles BOTH contexts: IPC in Electron, location/window
  // in the browser — required for Electron/browser parity.
  ElectronAPI.openUrl(`mailto:${supportEmail()}`);
};
